<!-- BulletedList.vue -->
<!-- Format an array of values with a list item  -->
<!-- You can override the item text or the list item element -->
<script lang="ts" setup>
import { computed } from 'vue';

    const props = defineProps<{
        items?: string[] | string
    }>();

    const itemArray = computed<string[]|undefined>(() => {
        if (Array.isArray(props.items)) {
            return props.items;
        } 
        
        if (typeof props.items === 'string') {
            return [props.items];
        }
    });

</script>

<template>
    <ul v-if="items?.length">
        <template v-for="item in itemArray">
            <slot name="listItem" :item="item">
                <li>
                    <slot name="item" :item="item">
                        {{ item }}
                    </slot>
                </li>
            </slot>
        </template>
    </ul>
</template>